import React, { ReactNode } from 'react';

interface IconContainerProps {
  icon: ReactNode;
  className?: string;
}

export const IconContainer = ({ icon, className }: IconContainerProps) => {
  return (
    <i className={className} aria-hidden="true">
      {icon}
    </i>
  )
};